/* fairlead-ar.js
   New 27 Oct 2026. Runs the "See it in your space" strip (snippets/product-media-gallery.liquid).
   1. Keeps the strip on the color the shopper picked. Rise re-renders the product section when the
      color changes but only copies the photo list across, so this swaps the strip wrapper
      (id ArStrip-<section>) and asks Shopify's AR script to pick up the new button.
   2. Computers: devices that cannot do AR get the strip's QR version. A click opens a small window
      with a QR code for this page, in the selected color. The QR library (assets/fl-qrcode.js)
      loads only on that first click.
   Loaded from sections/main-product.liquid only when the product has a 3D model. */
(function () {
  // Same test Shopify's AR script uses: iOS / iPadOS Quick Look, or Android Scene Viewer.
  function canAR() {
    try {
      var a = document.createElement('a');
      if (a.relList && a.relList.supports && a.relList.supports('ar')) return true;
    } catch (e) {}
    return /android/i.test(navigator.userAgent);
  }
  var useQR = !canAR();

  function showQRStrips() {
    if (!useQR) return;
    document.querySelectorAll('[data-fl-ar-qr]').forEach(function (button) {
      button.hidden = false;
    });
  }

  // The phone opens the same page and color. In a theme preview the link keeps the preview theme.
  function pageUrl() {
    var url = new URL(window.location.href);
    url.hash = '';
    var theme = window.Shopify && window.Shopify.theme;
    if (theme && theme.role && theme.role !== 'main' && theme.id) {
      url.searchParams.set('preview_theme_id', theme.id);
    }
    return url.toString();
  }

  var libLoading = null;
  function loadLib(src) {
    if (typeof window.qrcode === 'function') return Promise.resolve();
    if (!libLoading) {
      libLoading = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }
    return libLoading;
  }

  function openQR(button) {
    var gallery = button.closest('media-gallery') || document;
    var dialog = gallery.querySelector('[data-fl-ar-qr-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    loadLib(dialog.dataset.lib).then(function () {
      var qr = window.qrcode(0, 'M');
      qr.addData(pageUrl());
      qr.make();
      dialog.querySelector('.fl-ar-qr__code').innerHTML = qr.createSvgTag({ cellSize: 4, margin: 0, scalable: true });
      dialog.showModal();
    });
  }

  document.addEventListener('click', function (event) {
    var qrButton = event.target.closest('[data-fl-ar-qr]');
    if (qrButton) {
      openQR(qrButton);
      return;
    }
    if (event.target.closest('[data-fl-ar-qr-close]')) {
      event.target.closest('dialog').close();
      return;
    }
    // A click on the dimmed area outside the window closes it.
    if (event.target.matches && event.target.matches('[data-fl-ar-qr-dialog]')) {
      var box = event.target.getBoundingClientRect();
      var outside = event.clientX < box.left || event.clientX > box.right ||
        event.clientY < box.top || event.clientY > box.bottom;
      if (outside) event.target.close();
    }
  });

  showQRStrips();

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var html = event && event.data && event.data.html;
    if (!html || typeof html.getElementById !== 'function') return;

    var swapped = false;
    document.querySelectorAll('[data-fl-ar]').forEach(function (slot) {
      var fresh = html.getElementById(slot.id);
      if (!fresh) return;
      slot.innerHTML = fresh.innerHTML;
      swapped = true;
    });

    if (!swapped) return;
    showQRStrips();
    if (window.ShopifyXR && typeof window.ShopifyXR.setupXRElements === 'function') {
      window.ShopifyXR.setupXRElements();
    }
  });
})();
